import { makeStyles, createStyles, Theme, lighten } from '@material-ui/core/styles';
import styles from 'assets/styles/default.scss';

export default makeStyles((theme: Theme) => createStyles({
  root: {
    width: '100%',
  },
  title: {
    fontFamily: '"Exo 2" !important',
    fontWeight: 700,
    fontSize: theme.typography.pxToRem(18),
    flexBasis: '33.33%',
    flexShrink: 0,
    flex: 1,
    paddingRight: theme.typography.pxToRem(15),
    wordBreak: 'break-word',
    '@media (max-width: 768px)': {
      alignSelf: 'flex-start',
      paddingRight: 0,
    }
  },
  chips: {
    '@media (max-width: 768px)': {
      marginTop: '15px',
      justifyContent: 'space-between',
      display: 'flex'
    }
  },
  expansionPanel: {
    borderColor: styles.secondarySicrediLight,
    borderWidth: '1px',
    borderStyle: 'solid',
    boxShadow: 'none'
  },
  details: {
    flexDirection: 'column'
  },
  descricao: {
    fontFamily: '"Nunito"'
  },
  pautaRow: {
    borderWidth: '0 0 1px 0',
    borderStyle: 'dashed',
    borderColor: styles.secondarySicrediLight,
    marginTop: theme.spacing(2),
  },
  item: {
    fontFamily: '"Nunito" !important',
    lineHeight: '24px',
    paddingTop: '9px',
    paddingBottom: '9px',
    color: styles.secondarySicrediDarker,
    whiteSpace: 'break-spaces'
  },
  timer: {
    marginRight: '20px',
    background: 'transparent !important',
  },
  acoes: {
    paddingTop: '10px',
    display: 'flex',
    justifyContent: 'flex-end',
    margin: '0 -4px',
    '@media (max-width: 768px)': {
      justifyContent: 'center',
    },
    '@media (max-width: 550px)': {
      flexDirection: 'column',
    }
  },
  botaoAcoes: {
    margin: '0 4px',
    '@media (max-width: 768px)': {
      flex: 1,
    },
    '@media (max-width: 550px)': {
      margin: '4px 0',
      width: '100%'
    }
  },
  botaoEditar: {
    margin: '0 4px',
    '@media (max-width: 768px)': {
      flex: 1,
    },
    '@media (max-width: 550px)': {
      margin: '4px 0',
      width: '100%'
    }
  },
  botaoVerResultados: {
    margin: '0 4px',
    borderColor: styles.primarySicrediLight,
    background: styles.primarySicrediLight,
    '&:hover': {
      borderColor: styles.primarySicrediLight,
      background: styles.primarySicrediLight,
    }
  },
  botaoDeletar: {
    backgroundColor: '#e60000',
    margin: '0 4px',
    '@media (max-width: 768px)': {
      flex: 1,
    },
    '@media (max-width: 550px)': {
      margin: '4px 0',
      width: '100%'
    },
    '&:hover': {
      backgroundColor: '#d21818',
    }
  },
  botaoBloquearResultados: {
    backgroundColor: styles.dangerSicrediDark,
    borderColor: styles.dangerSicrediDark,
    color: '#FFF',
    margin: '0 4px',
    '@media (max-width: 768px)': {
      flex: 1,
    },
    '@media (max-width: 550px)': {
      margin: '4px 0',
      width: '100%'
    },
    '&:hover': {
      backgroundColor: lighten(styles.dangerSicrediDark, 0.3),
      borderColor: styles.dangerSicrediDark,
    }
  },
  buttonEleicao: {
    float: 'right',
    color: '#D7E6C8',
    [theme.breakpoints.down('sm')]: {
      width: '30%',
    }
  },
  buttonEleicaoAssociado: {
    float: 'right',
    color: '#D7E6C8',
    width: '20%',
    [theme.breakpoints.down('sm')]: {
      width: '30%',
    }
  },
  iconButton: {
    [theme.breakpoints.down('sm')]: {
      width: '35%',
    }
  },
  textButtonEleicao: {
    color: '#33820D',
    fontSize: '12px',
    marginLeft: '5px',
    [theme.breakpoints.down('sm')]: {
      fontSize: '10px'
    }
  },
  statusChipBloqueada: {
    backgroundColor: styles.dangerSicrediLight + ' !important',
    color: styles.dangerSicrediDark + ' !important',
  },
  statusChipEncerrada: {
    color: styles.secondarySicrediDarker + ' !important',
  },
  statusChipLiberada: {
    backgroundColor: styles.primarySicrediLight + ' !important',
    color: styles.secondarySicrediDarker + ' !important',
  },
  statusIconChipLiberada: {
    color: styles.primarySicrediDark + ' !important',
  },
  pautaFooter: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    alignItems: 'flex-end',
  },
  pautaFooterLabel: {
    display: 'inline-flex',
    paddingBottom: theme.spacing(1)
  }
}), { name: 'AssembleiaPauta' });

export const pautasUseStyles = makeStyles((theme: Theme) => createStyles({
  wrapper: {
    marginTop: theme.spacing(1),
  },
}), { name: 'AssembleiaPautas' });
